export var ExecutionType;
(function (ExecutionType) {
    ExecutionType["Initial"] = "initial";
    ExecutionType["Reminder"] = "reminder";
})(ExecutionType || (ExecutionType = {}));
export var EmailStatus;
(function (EmailStatus) {
    EmailStatus["Sent"] = "SENT";
    EmailStatus["Failed"] = "FAILED";
    EmailStatus["Running"] = "RUNNING";
})(EmailStatus || (EmailStatus = {}));
